import { render, staticRenderFns } from "./SettingPlanDetailPad.vue?vue&type=template&id=8b52fde6&scoped=true"
import script from "./SettingPlanDetailPad.vue?vue&type=script&lang=js"
export * from "./SettingPlanDetailPad.vue?vue&type=script&lang=js"
import style0 from "./SettingPlanDetailPad.vue?vue&type=style&index=0&id=8b52fde6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b52fde6",
  null
  
)

export default component.exports